import { useState } from "react";
import { api, ApiError } from "../lib/api";
import { Link, navigate } from "../lib/router";
import { useSession } from "../lib/session";
import { useToast } from "../lib/toast";
import { SignInPanel } from "../components/SignInPanel";

export default function Account() {
  const { me, loading, refresh, signOut } = useSession();
  const toast = useToast();
  const [name, setName] = useState<string | null>(null);
  if (loading) return <div className="page narrow"><p className="muted">Loading…</p></div>;
  if (!me?.user) return <div className="page narrow"><h1>Account</h1><SignInPanel /></div>;
  const u = me.user;
  const a = me.access;

  const saveName = async () => {
    try {
      await api.updateMe({ displayName: name ?? "" });
      await refresh();
      setName(null);
      toast("Name updated");
    } catch (err) {
      toast((err as ApiError).message, "error");
    }
  };
  const erase = async () => {
    if (!confirm("Delete your account, saved lessons, adaptations and class profiles? Any subscription will be cancelled. This can't be undone.")) return;
    try {
      await api.deleteAccount();
    } catch (err) {
      return toast((err as ApiError).message, "error");
    }
    await refresh();
    navigate("/");
    toast("Your account has been deleted");
  };

  return (
    <div className="page narrow">
      <h1>Account</h1>
      <dl className="facts">
        <div><dt>Email</dt><dd>{u.email}</dd></div>
        <div>
          <dt>Name</dt>
          <dd>
            {name === null ? (
              <>{u.displayName || <span className="muted">Not set</span>} <button className="btn-link" onClick={() => setName(u.displayName ?? "")}>Edit</button></>
            ) : (
              <span className="inline-form">
                <input aria-label="Display name" maxLength={60} value={name} onChange={(ev) => setName(ev.target.value)} />
                <button className="btn btn-primary" onClick={() => void saveName()}>Save</button>
              </span>
            )}
          </dd>
        </div>
        <div><dt>Plan</dt><dd>{a.state === "subscribed" ? `${a.subscription?.plan === "yearly" ? "Yearly" : "Monthly"} · ${a.subscription?.renews ? "renews" : "ends"} ${new Date(a.subscription!.periodEnd!).toLocaleDateString()}` : a.state === "trial" ? `Free trial until ${new Date(a.trialEndsAt!).toLocaleDateString()}` : a.state === "complimentary" ? "Complimentary" : "No active plan"} · <Link to="/pricing">{a.state === "subscribed" ? "manage" : "see plans"}</Link></dd></div>
        <div><dt>AI adaptations</dt><dd>{me.usage.adapt.remaining} of {me.usage.adapt.limit} left (rolling 24 hours)</dd></div>
        <div><dt>Member since</dt><dd>{new Date(u.createdAt).toLocaleDateString(undefined, { dateStyle: "long" })}</dd></div>
      </dl>
      <div className="actions-row">
        <button className="btn" onClick={() => void signOut().then(() => navigate("/"))}>Sign out</button>
        <button className="btn btn-danger" onClick={() => void erase()}>Delete account</button>
      </div>
    </div>
  );
}
